// extracted by css-extract-rspack-plugin
export default {"root":"jqymlN","icon":"Yn6Azq"};